/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import TableCell from '@material-ui/core/TableCell';
import EditIcon from '@material-ui/icons/Edit';
import OkIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import TableRow from '@material-ui/core/TableRow';
import BodyCell from './BodyCell';

const getColKey = (col, i) => `${col.name}${i}`;

class BodyRow extends React.PureComponent {
  static propTypes = {
    row: PropTypes.shape({}).isRequired,
    className: PropTypes.string,
    RowButtons: PropTypes.func,
    checked: PropTypes.bool,
    selected: PropTypes.bool,
    canEdit: PropTypes.bool.isRequired,
    editing: PropTypes.bool.isRequired,
    canCheck: PropTypes.bool.isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    values: PropTypes.arrayOf(PropTypes.any).isRequired,
    fvalues: PropTypes.arrayOf(PropTypes.any).isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
    canDelete: PropTypes.bool.isRequired,
    showActionButtons: PropTypes.bool,
    tableHandler: PropTypes.shape({
      getTableRowId: PropTypes.func,
      onSelectClick: PropTypes.func,
      onCheckClick: PropTypes.func,
      onStartEditing: PropTypes.func,
      onStopEditing: PropTypes.func,
      onCancelEditing: PropTypes.func,
      getString: PropTypes.func,
    }).isRequired,
  };

  static defaultProps = {
    className: undefined,
    checked: false,
    selected: false,
    RowButtons: undefined,
    showActionButtons: true,
    errors: undefined,
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   const { row } = nextProps;
  //   console.log('     shouldComponentUpdate row ', row.id);
  //   let update = false;
  //   Object.keys(this.props).forEach((key) => {
  //     if (this.props[key] !== nextProps[key]) {
  //       update = true;
  //       console.log(`          ${key}`);
  //     }
  //   });
  //   return update;
  // }

  render() {
    const {
      row,
      RowButtons,
      columns,
      tableHandler,
      checked,
      selected,
      canCheck,
      editing,
      canEdit,
      canDelete,
      showActionButtons,
      values,
      fvalues,
      className,
      errors,
    } = this.props;
    const { getTableRowId } = tableHandler;
    function handleSelectClick(event) {
      tableHandler.onSelectClick(event, row);
    }
    function handleCheckClick(event) {
      tableHandler.onCheckClick(event, row);
    }
    function handleStartEditing() {
      tableHandler.onStartEditing(row);
    }
    function handleStopEditing() {
      tableHandler.onStopEditing(row);
    }
    function handleCancelEditing() {
      tableHandler.onCancelEditing(row);
    }
    const hasErrors = errors && !!errors.find(e => e);
    return (
      <TableRow
        hover
        onClick={handleSelectClick}
        role="checkbox"
        aria-checked={checked}
        tabIndex={-1}
        selected={selected}
        id={getTableRowId ? getTableRowId(row) : undefined}
        className={className}
      >
        {canCheck && (
          <TableCell padding="checkbox" className="tuc-table-cell-checkbox">
            <Checkbox checked={checked} onClick={handleCheckClick} />
          </TableCell>
        )}
        {columns.map((col, iCol) => {
          const editColumn = editing && (col.editable === undefined || col.editable);
          const key = getColKey(col, iCol);
          return (
            <BodyCell
              {...this.props}
              column={col}
              index={iCol}
              editing={editColumn}
              key={key}
              value={values[iCol]}
              fvalue={fvalues[iCol]}
              error={editColumn && errors && errors[iCol] || ''}
              object={row}
            />
          );
        })}
        {(canEdit || canDelete || RowButtons) && (
          <TableCell key="editing" padding="checkbox" className="tuc-table-edit-column">
            <div className="tuc-button-row">
              {editing && (
                <Tooltip title="Validate">
                  <div>
                    <IconButton
                      aria-label="Validate"
                      className="tuc-table-edit-row-button"
                      disabled={hasErrors}
                      onClick={handleStopEditing}
                    >
                      <OkIcon />
                    </IconButton>
                  </div>
                </Tooltip>
              )}
              {canEdit && showActionButtons && (
                <Tooltip title={tableHandler.getString('editRow', 'Edit row')}>
                  <IconButton aria-label="Edit" className="tuc-table-edit-row-button" onClick={handleStartEditing}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              )}
              {editing && (
                <Tooltip title="Cancel editing">
                  <IconButton
                    aria-label="Cancel"
                    className="tuc-table-edit-row-button"
                    onClick={handleCancelEditing}
                  >
                    <CancelIcon />
                  </IconButton>
                </Tooltip>
              )}
              {!editing && RowButtons && (
                <RowButtons {...this.props} row={row} />
              )}
            </div>
          </TableCell>
        )}
      </TableRow>
    );
  }
}

export default BodyRow;
